import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FOOTER_SECTIONS } from './constants/footer.constans';
import { Newsletter } from './components/newsletter/newsletter';
import { LocalizationService } from '../../../services/localization/localization.service';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'smm-footer',
  imports: [TranslateModule, Newsletter, NgOptimizedImage],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Footer {
  private _localization = inject(LocalizationService);
  private _navigation = inject(NavigationService);
  private _router = inject(Router);

  footerSections = FOOTER_SECTIONS;

  toggleLang() {
    this._localization.changeLang();
  }

  scrollToSection(id: string) {
    this._navigation.scrollToSection(id);
  }

  handleNavClick(fragment: string) {
    if (this._router.url === '/' || this._router.url === '/#') {
      this.scrollToSection(fragment);
    } else {
      this._router.navigate(['/']).then(() => {
        setTimeout(() => {
          this.scrollToSection(fragment);
        }, 100);
      });
    }
  }
}
